import script from "./OnboardingAiStepHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiStepHeader.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiStepHeader.vue?vue&type=style&index=0&id=d78621fc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d78621fc"]])

export default __exports__